<h2 class="section-subtitle">Inventory - {{ character.load() }}cn / {{ character.maximumLoad() }}cn</h2>
<div class="container" id="inventory">
  <mat-card appearance="outlined">
    <mat-card-content>
      <mat-list dense>
        <h2>Weapons:</h2>
        <item-list [items]="character.weapons" [capacity]="4"></item-list>
      </mat-list>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-content>
      <mat-list dense>
        <h2>Armor:</h2>
        <item-list [items]="character.armor" [capacity]="4"></item-list>
      </mat-list>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-content>
      <mat-list dense>
        <h2>Slung Items:</h2>
        @for (si of character.getSlungItems(); track si) {
          <div>
            <mat-list-item [class.overfull]="si.unequipped" (click)="openContainerDialog(si)">{{ si.inventoryString() }}
              <div class="mat-list-actions">
                <mat-icon [color]="si.unequipped ? 'primary' : 'warn'" class="equip-icon"
                  [class.unequipped]="si.unequipped" (click)="toggleEquip(si, $event)">pan_tool
                </mat-icon>
              </div>
            </mat-list-item>
            <mat-divider></mat-divider>
          </div>
        }
        <div class="add-item">
          @if (character.getSlungItems().length < 5) {
            <button mat-mini-fab (click)="openContainerDialog()"
              color="primary">
              <mat-icon>add</mat-icon>
            </button>
          }
        </div>
      </mat-list>
    </mat-card-content>
  </mat-card>
  @for (si of character.getSlottedContainers(); track si) {
    <mat-card appearance="outlined">
      <mat-card-content>
        <h2 [matTooltip]="si.isBackpack() ? slotShadingTooltip : ''">@if (si.unequipped) {
          <span>Unequipped</span>
        } {{ si.inventoryString(false) }} </h2>
        <h3 [class.overfull]="si.isOverfull()">{{ si.capacityString() }}</h3>
        <item-list [capacity]="si.slots" [items]="si.contents" [banded]="si.isBackpack()"></item-list>
      </mat-card-content>
    </mat-card>
  }
</div>
